var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.096,
    height: 22,
    viewBox: "0 0 20.096 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: #bcbccb;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: #fff;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: none;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: none;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notification",
    transform: "translate(-1395 -20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Notification_Icon",
    "data-name": "Notification Icon",
    className: "cls-1",
    d: "M5.714,13.334H9.524a1.9,1.9,0,1,1-3.809,0ZM.952,12.381a.952.952,0,0,1,0-1.9h.476A4.146,4.146,0,0,0,2.857,7.619V4.762A4.716,4.716,0,0,1,7.619,0,4.716,4.716,0,0,1,12.38,4.762V7.619a4.144,4.144,0,0,0,1.429,2.858h.477a.952.952,0,0,1,0,1.9Z",
    transform: "translate(1395 26.762)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Notification_Badge",
    "data-name": "Notification Badge",
    className: "cls-2",
    transform: "translate(1405.476 22)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 3.809,
    cy: 3.809,
    r: 3.809
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 3.809,
    cy: 3.809,
    r: 4.809
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification1);
export default __webpack_public_path__ + "static/media/Notification1.17af65c78ac0f5ae9f46e599b5d13124.svg";
export { ForwardRef as ReactComponent };